import { baseApi } from '@shared/api'
import { AsanVerifyRequest, AsanVerifyResponse } from './types'

const verifyApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchVerifyAsanSign: builder.mutation<AsanVerifyResponse, AsanVerifyRequest>({
      query: (args) => ({
        url: '/ib/signing/asan/verify',
        data: args,
        method: 'POST',
        skipGlobalError: true,
      }),
    }),
  }),
})

export const { useFetchVerifyAsanSignMutation } = verifyApi
